import React, { FC } from 'react';

import Link from 'next/link';
import router from 'next/router';

import DialogWrapper from '@components_iqfu/dashboard/dialog/dialog_wrapper/DialogWrapper';

import styles from './RequestContractDetail.module.scss';

type Props = {
  sellingContaractId: number;
  onClose: () => void;
  open: boolean;
  fullWidth?: boolean;
};

const RequestContractDetailDialog: FC<Props> = ({ sellingContaractId, onClose, open, fullWidth }) => {
  const userType = router.pathname.includes('financial_agency') ? 'financial_agency' : 'company';
  return (
    <>
      <DialogWrapper onClose={onClose} open={open} fullWidth={fullWidth}>
        <div className={styles.dialog_inner}>
          <p className={styles.title}>※成約事例詳細</p>
          <p className={styles.dialog_alert_text}>
            1000円課金します。
            <br />
            よろしいですか？
          </p>
          <div className={styles.button_wrapper}>
            <Link href={`/console/${userType}/iqfu_pro/${sellingContaractId}`} passHref>
              <a className={styles.submit_button}>閲覧する</a>
            </Link>
            <button className={styles.delete_button} onClick={onClose}>
              キャンセル
            </button>
          </div>
        </div>
      </DialogWrapper>
    </>
  );
};

export default RequestContractDetailDialog;
